// Brand mark shared with the mobile app (woodpecker-app/assets/brand/logo_mark.png,
// resized into public/brand). Rounded like the app's BrandMark: radius = 26% of size.
export const BRAND_LOGO = "/brand/logo-mark-128.png";
